import * as Data$dShow from "../Data.Show/index.js";
import * as Restaumatic$dI18n from "../Restaumatic.I18n/index.js";
import * as Restaumatic$dSite$dI18n from "../Restaumatic.Site.I18n/index.js";
const saveOrderPath = () => {
  const locale = Restaumatic$dSite$dI18n.getGlobalLocale();
  const defaultLocale = Restaumatic$dI18n.getGlobalDefaultLocale();
  return Restaumatic$dSite$dI18n._localizePath(locale)(defaultLocale)("zamowienie/zapisz");
};
const reservationPath = () => {
  const locale = Restaumatic$dSite$dI18n.getGlobalLocale();
  const defaultLocale = Restaumatic$dI18n.getGlobalDefaultLocale();
  return Restaumatic$dSite$dI18n._localizePath(locale)(defaultLocale)("rezerwuj-stolik");
};
const paymentChannelsPath = v => {
  const $0 = "/payments/channels?restaurant_id=" + Data$dShow.showIntImpl(v);
  return () => $0;
};
const checkoutPath = () => {
  const locale = Restaumatic$dSite$dI18n.getGlobalLocale();
  const defaultLocale = Restaumatic$dI18n.getGlobalDefaultLocale();
  return Restaumatic$dSite$dI18n._localizePath(locale)(defaultLocale)("zamowienie/koszyk");
};
const checkoutPathWithRestaurantId = v => () => {
  const p = checkoutPath();
  return p + "/" + Data$dShow.showIntImpl(v);
};
const checkCouponPath = () => {
  const locale = Restaumatic$dSite$dI18n.getGlobalLocale();
  const defaultLocale = Restaumatic$dI18n.getGlobalDefaultLocale();
  return Restaumatic$dSite$dI18n._localizePath(locale)(defaultLocale)("promocje/sprawdz_kupon");
};
export {checkCouponPath, checkoutPath, checkoutPathWithRestaurantId, paymentChannelsPath, reservationPath, saveOrderPath};
